module.exports = __webpack_public_path__ + "img/logowht-en.176297cc.svg";